function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.252 6.405V8.41c.033.418-.058.853-.273 1.174-.372.555-.976.555-1.349 0L.491 6.237a1.072 1.072 0 01-.176-.189L.28 6.012C.092 5.732-.001 5.366 0 5c0-.159.017-.318.052-.47.084-.372.269-.675.506-.838L3.63.417c.373-.556.977-.556 1.35 0 .214.32.305.755.272 1.173v1.972h14.794c.527 0 .954.636.954 1.421s-.427 1.422-.954 1.422H5.252z",
  fill: "currentColor"
});

var SvgArrowPrev = function SvgArrowPrev(props) {
  return React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='21' height='10' viewBox='0 0 21 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.25186 6.40467V8.41037C5.28515 8.82809 5.19433 9.26347 4.97936 9.58384C4.6069 10.139 4.00286 10.1387 3.63013 9.58318L0.491287 6.23751C0.428972 6.18601 0.369709 6.12332 0.314824 6.04942L0.279702 6.01198C0.0922362 5.73261 -0.000999866 5.366 8.08511e-06 4.99996C-0.000429383 4.84109 0.016886 4.68211 0.0519531 4.53021C0.135929 4.15797 0.320532 3.85458 0.557613 3.69172L3.63013 0.416881C4.00286 -0.138677 4.6069 -0.138975 4.97936 0.416075C5.19433 0.736567 5.28515 1.17196 5.25186 1.58966V3.56173H20.0456C20.5727 3.56173 21 4.19815 21 4.98329C21 5.76833 20.5727 6.40467 20.0456 6.40467H5.25186Z' fill='currentColor' /%3E %3C/svg%3E";
export { SvgArrowPrev as ReactComponent };